import {
  useEffect,
  useState,
  useRef,
  memo,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Row, Col, Tooltip, MessageBox, Button, message } from 'kenshin';
import EditItem from './EditItem';
import styles from '../style.less';
import { deepClone } from '@/_util';
import { getTaskTagList } from '@/_serveice/project';
import { getEmpRptHistoryTagId } from '@/_serveice/usercenter';

const RptModal = memo(
  ({
    selectRows,
    usercenter,
    timeData,
    getHasRptTime,
    visible,
    onCancel,
    loading,
    reportDate,
    onSave,
  }) => {
    let rowArr = selectRows || [];
    let value = Array.from(new Set(rowArr.map((item) => item.projectId))).map(
      (item) => ({
        projectId: item,
        list: rowArr.filter((data) => data.projectId == item),
      }),
    );

    const [taskTagOptionsMap, setTaskTagOptionsMap] = useState({});
    const [historyTagIdMap, setHistoryTagIdMap] = useState({});

    const editRef = useRef([]);
    useEffect(() => {
      if (visible) {
        editRef.current = [];
        rseData.current = [];
        map.current = new Map();

        let cancelled = false;
        let taskIdList = Array.from(
          new Set(
            (selectRows || []).map((item) => item.taskId).filter(Boolean),
          ),
        );
        if (taskIdList.length === 0) {
          setTaskTagOptionsMap({});
          return () => {
            cancelled = true;
          };
        }
        const muId = localStorage.getItem('muId');
        Promise.all(
          taskIdList.map((taskId) =>
            getTaskTagList({ type: 3, taskId, empIdString: muId }).then(
              (res) => ({
                taskId,
                data: res?.data || [],
              }),
            ),
          ),
        ).then((list) => {
          if (cancelled) return;

          let nextMap = {};
          list.forEach(({ taskId, data }) => {
            nextMap[taskId] = data.map((item) => ({
              label: <Tooltip title={item.extendData}>{item.value}</Tooltip>,
              value: item.id,
            }));
          });
          setTaskTagOptionsMap(nextMap);

          // 调用API获取历史标签数据
          Promise.all(
            taskIdList.map((taskId) =>
              getEmpRptHistoryTagId({ empId: muId, taskId }).then((res) => ({
                taskId,
                tagId: res?.data || null,
              })),
            ),
          ).then((historyList) => {
            if (cancelled) return;

            let historyMap = {};
            historyList.forEach(({ taskId, tagId }) => {
              if (tagId) {
                historyMap[taskId] = tagId;
              }
            });
            setHistoryTagIdMap(historyMap);
          });
        });

        return () => {
          cancelled = true;
        };
      }
    }, [visible, selectRows]);

    const rseData = useRef();

    let map = useRef(new Map());

    const handleChange = (val, key, obj) => {
      map.current.set(`${obj.projectId}-${obj.taskId}`, {
        ...val,
        ...obj,
      });
      rseData.current = Array.from(map.current).map((item) => item[1]);
    };

    const handleSave = () => {
      let error = [];
      // 校验每个表单的workTime和taskTagList字段
      editRef.current.forEach((item) => {
        const workTimeError = item.getFieldError('workTime').length > 0;
        const taskTagError = item.getFieldError('taskTagList').length > 0;
        error.push(workTimeError || taskTagError);
        // 触发表单验证，显示错误信息
        item.validateFields();
      });
      let timeList = [
        ...rseData.current,
        ...usercenter.empCurTimesLot.map((item) => ({
          workBeginTime: item.beginDate,
          workEndTime: item.endDate,
        })),
      ];
      for (let i = 0; i < timeList.length; i++) {
        for (let j = i + 1; j < timeList.length; j++) {
          let start1 = new Date(timeList[i].workBeginTime).getTime();
          let end1 = new Date(timeList[i].workEndTime).getTime();
          let start2 = new Date(timeList[j].workBeginTime).getTime();
          let end2 = new Date(timeList[j].workEndTime).getTime();
          if (start1 < end2 && start2 < end1) {
            return message.error(`上报时间存在冲突，请检查！`);
          }
        }
      }

      // 如果错误列表中无true(错误数量>0)则全部通过
      if (!error.includes(true)) {
        const params = rseData.current.map((item) => {
          return {
            ...item,
            taskTagList: undefined,
            taskTagId: item.taskTagList?.[0]?.id,
          };
        });
        onSave?.(params);
      }
    };
    console.log('value', value, taskTagOptionsMap);
    return (
      <MessageBox
        width="80%"
        title={`${reportDate ? '补' : '上'}报：${moment(reportDate).format(
          'MM-DD',
        )}`}
        destroyOnClose
        visible={visible}
        onCancel={onCancel}
        confirmLoading={loading}
        onOk={handleSave}
      >
        <span>已上报时间段：</span>
        {deepClone(usercenter.empCurTimesLot)
          ?.sort((a, b) => a.beginDate - b.beginDate)
          .map((item, i) => (
            <div key={i} style={{ color: '#4389f9' }}>
              {moment(item.beginDate).format('YYYY-MM-DD HH:mm:ss')}~{' '}
              {moment(item.endDate).format('YYYY-MM-DD HH:mm:ss')}
              <span
                style={{
                  marginLeft: 10,
                  color: '#4389f9',
                }}
              >
                {item.remark}{' '}
              </span>
            </div>
          ))}
        {value.map((item, baseIndex) => (
          <div key={item.projectId}>
            <Row className={styles.rptCard}>
              <Col flex="200px">
                {
                  usercenter.usercenterList.datas?.find(
                    (pageData) => pageData.projectId == item.projectId,
                  )?.projectName
                }{' '}
              </Col>
              <Col flex="200px">
                个人累计工时
                <Tooltip title="个人当前项目所有工作包已上报的累计工时">
                  <QuestionCircleOutlined />
                </Tooltip>
                ：{timeData?.[item.projectId]?.projectTime ?? 0}{' '}
              </Col>
              <Col flex="200px">
                今日累计工时
                <Tooltip title="个人当前项目所有工作包今日已上报的累计工时">
                  <QuestionCircleOutlined />
                </Tooltip>
                ：{timeData?.[item.projectId]?.projectCurTime ?? 0}{' '}
              </Col>
            </Row>
            {item.list.map((lisItem, index) => {
              let calHeaderl = (
                <Row className={styles.detailHeader}>
                  <Col flex="250px">
                    <span className="c999">
                      {lisItem.servCatgName || lisItem.proServCatgName}
                      &gt; {lisItem.taskName}{' '}
                    </span>
                  </Col>
                  <Col flex="250px">
                    累计上报工时：
                    <span className="c999">
                      {timeData?.[item.projectId]?.[
                        `${item.projectId}_${lisItem.proServCatgId}`
                      ] || 0}{' '}
                    </span>
                  </Col>
                </Row>
              );

              return (
                <EditItem
                  getHasRptTime={getHasRptTime}
                  key={lisItem.taskId}
                  disabled
                  expand
                  reportDate={reportDate}
                  data={lisItem}
                  tagList={taskTagOptionsMap?.[lisItem.taskId] || []}
                  disabledTime={[...usercenter.empCurTimesLot]}
                  headerEl={calHeaderl}
                  onChange={(val, err) => {
                    handleChange(val, index, {
                      taskId: lisItem.taskId,
                      projectId: item.projectId,
                      proServCatgId: lisItem.proServCatgId,
                    });
                  }}
                  getRef={(ref) => editRef.current.push(ref)}
                  historyTagId={historyTagIdMap?.[lisItem.taskId] || null}
                />
              );
            })}{' '}
          </div>
        ))}{' '}
      </MessageBox>
    );
  },
);

export default RptModal;
